"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const weekSort_1 = __importDefault(require("./weekSort"));
const asFloat_1 = __importDefault(require("../Util/asFloat"));
const Unit_1 = require("./Unit");
const resultPlaceholder_1 = __importDefault(require("./resultPlaceholder"));
class Results {
    constructor(api, customerClient, strategy, fetch, dateTimeBridge) {
        this.getAvailableMeasurements = async (customerId, unit, lengthUnit) => {
            const result = await this.strategy.get(`MEASUREMENTS.${customerId}`, async (_prev) => true, async (_prev) => {
                const customer = await this.customerClient.fetchCustomer(customerId);
                const allMeasurements = (await this.api.getMeasurements(customer)).sort(weekSort_1.default);
                return {
                    availableWeeks: allMeasurements
                        .sort((a, b) => (a.createdAtRaw > b.createdAtRaw ? 1 : -1))
                        .map(({ week, createdAtRaw }) => ({
                        week,
                        id: Results.idFromDateTime(createdAtRaw),
                    })),
                    measurements: allMeasurements,
                };
            });
            if (unit !== "kg") {
                result.measurements = result.measurements.map(this.convertWeightToLbs);
            }
            if (lengthUnit === Unit_1.Unit.IMPERIAL) {
                result.measurements = result.measurements.map(this.convertToImperialUnit);
            }
            return {
                ...result,
                measurements: result.measurements.map((measurement) => ({
                    ...measurement,
                    createdAt: this.dateTimeBridge.userDate(measurement.createdAtRaw),
                })),
            };
        };
        this.getMeasurementPhotos = (customerId, id, rawPhotos = false) => {
            return this.strategy.get(`MEASUREMENTS.${customerId}.${id}.PHOTOS`, 
            // TODO: redundant conditional, it should and it is, checked by strategy
            async (photos) => !photos, async () => {
                const measurementBundle = await this.getAvailableMeasurements(customerId, "kg");
                const measurement = measurementBundle.measurements.find(({ createdAtRaw: dateComp }) => Results.idFromDateTime(dateComp) === id);
                if (rawPhotos) {
                    return {
                        photoFront: measurement === null || measurement === void 0 ? void 0 : measurement.rawPhotos.photoFront,
                        photoSide: measurement === null || measurement === void 0 ? void 0 : measurement.rawPhotos.photoSide,
                        photoBack: measurement === null || measurement === void 0 ? void 0 : measurement.rawPhotos.photoBack,
                    };
                }
                return this.fetchImagesAsBase64(measurement === null || measurement === void 0 ? void 0 : measurement.rawPhotos);
            });
        };
        this.fetchImagesAsBase64 = async (photos) => {
            return {
                photoFront: await this.fetchImageAsBase64(photos.photoFront),
                photoSide: await this.fetchImageAsBase64(photos.photoSide),
                photoBack: await this.fetchImageAsBase64(photos.photoBack),
            };
        };
        this.fetchImageAsBase64 = async (url) => {
            if (!url.substr(0, 4).includes("http")) {
                return url;
            }
            return this.fetch.fetch(url, {}, true, resultPlaceholder_1.default);
        };
        this.checkNextMeasurements = (next) => {
            if (!next)
                return null;
            return {
                week: next.week,
                date: next.date.iso8601,
            };
        };
        this.convertMeasurementUnit = (measurement, unit, lengthUnit) => {
            if (!measurement)
                return null;
            if (unit !== "kg") {
                measurement = this.convertWeightToLbs(measurement);
            }
            if (lengthUnit === Unit_1.Unit.IMPERIAL) {
                measurement = this.convertToImperialUnit(measurement);
            }
            return measurement;
        };
        this.getMeasurementInfo = async (customerId, unit, lengthUnit) => {
            const getRequest = async () => {
                const { lastMeasurement, nextMeasurement } = await this.api.getMeasurementInfo(customerId);
                return {
                    lastMeasurement: await this.convertMeasurementUnit(lastMeasurement, unit, lengthUnit),
                    nextMeasurement: this.checkNextMeasurements(nextMeasurement),
                };
            };
            return (await this.strategy.get(`MEASUREMENT.${customerId}`, () => Promise.resolve(true), getRequest));
        };
        this.convertToImperialUnit = (measurement) => {
            return {
                ...measurement,
                height: this.cmToFeet(measurement.height),
                shoulders: this.cmToInch(measurement.shoulders),
                waist: this.cmToInch(measurement.waist),
                breast: this.cmToInch(measurement.breast),
                legs: this.cmToInch(measurement.legs),
            };
        };
        this.convertWeightToLbs = (measurement) => {
            return {
                ...measurement,
                weight: (0, asFloat_1.default)(parseFloat(measurement.weight) * 2.20462262, 2).toString(),
            };
        };
        this.cmToInch = (length) => (0, asFloat_1.default)(parseFloat(length) * 0.393700787, 2).toString();
        this.cmToFeet = (length) => (0, asFloat_1.default)(parseFloat(length) * 0.032808399, 2).toString();
        this.api = api;
        this.customerClient = customerClient;
        this.strategy = strategy;
        this.fetch = fetch;
        this.dateTimeBridge = dateTimeBridge;
    }
    static idFromDateTime(createdAtRaw) {
        return createdAtRaw.slice(0, 10);
    }
}
exports.default = Results;
//# sourceMappingURL=Results.js.map